<template>
    <component :is="stationComponent" v-bind="componentProps" />
</template>
<script setup>
import { sortBy } from 'lodash-es';
import { usePageStore } from '~dsc/stores/cms/page';
import { resolveComponent, storeToRefs, computed, useI18n } from '#imports';

const { station } = storeToRefs(usePageStore());
const { t } = useI18n({
    useScope: 'global',
});

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    contentType: {
        type: String,
        required: false,
        default: 'stationLocator',
    },
    type: {
        type: String,
        required: false,
        default: 'list',
    },
    data: {
        type: Array,
        required: false,
        default: () => [],
    },
    prefix: {
        type: String,
        required: false,
        default: '/asemat/',
    },
    filters: {
        type: Object,
        required: false,
        default: () => undefined,
    },
});

const stations = computed(() => {
    const stationListFormat = ({ station: { id, stationTypes: type = [], name: title }, path }) => ({
        id,
        type,
        title,
        links: [
            {
                to: `/${path}`,
                title: isType(type),
            },
        ],
    });

    return sortBy(props.data.map(stationListFormat), 'title');
});

const componentProps = computed(() => ({
    stations: props.type === 'list' ? stations : station,
    filters: props.filters,
    class: {
        'station-page-content': true,
        'block': props.type === 'foodMenu',
    },
}));

const stationComponent = computed(() => {
    switch (props.type.toLowerCase()) {
        case 'preorder':
            return resolveComponent('BlocksStationsPreorder');
        case 'header':
            return resolveComponent('BlocksStationsHeader');
        case 'lunch':
            return resolveComponent('BlocksStationsLunch');
        case 'lunchlist':
            return resolveComponent('BlocksStationsLunchList');
        case 'attributes':
            return resolveComponent('BlocksStationsAttributes');
        case 'foodmenu':
            return resolveComponent('BlocksCLFoodMenu');
        case 'autopesu':
            return resolveComponent('BlocksStationsAutopesu');
        case 'map':
            return resolveComponent('BlocksStationMap');
        case 'grouporder':
            return resolveComponent('BlocksStationsGrouporder');
        case 'list':
            return resolveComponent('BlocksStationsList');
    }

    return null;
});

const isType = (types = []) => {
    if (types.includes('helmisimpukkarestaurant')) {
        return t('restaurant');
    } else if (types.includes('helmisimpukka')) {
        return t('express');
    }

    return t('station');
};
</script>
<style scoped>
.station-page-content:not(.todays-lunch):not(:last-child) {
  margin-bottom: 2rem;
}
</style>
